import { toast } from 'sonner';

export const getErrorMessage = (error: unknown): string => {
  if (error instanceof Error) return error.message;
  if (typeof error === 'string') return error;
  if (error && typeof error === 'object' && 'message' in error) {
    return String((error as { message: unknown }).message);
  }
  return '操作失败';
};

export const handleError = (
  error: unknown,
  context?: string,
  showToast: boolean = true
): void => {
  const message = getErrorMessage(error);
  const fullMessage = context ? `${context}: ${message}` : message;
  if (import.meta.env.DEV) {
    console.error(`[Error${context ? ` - ${context}` : ''}]`, error);
  }
  if (showToast) {
    toast.error(fullMessage);
  }
};

export const handleApiError = (
  error: { message?: string; code?: string } | null,
  context: string
): void => {
  if (!error) return;
  handleError(error.message || '请求失败', context);
};

export const logError = (error: unknown, context?: string): void => {
  if (import.meta.env.DEV) {
    console.error(`[Silent Error${context ? ` - ${context}` : ''}]`, error);
  }
};
